import { servicesListSaga } from './servicesList';
import { companyServicesSaga } from './companyServices';
import { serviceItemSaga } from './serviceItem';

export const servicesSaga = [
    ...servicesListSaga,
    ...companyServicesSaga,
    ...serviceItemSaga,
];
